import { TFunction } from 'i18next';
import { getPositionsWithIcons } from './positions';

export const getInitialTemplate = (t: TFunction) => ({
  type: 'text',
  title: '',
  position: getPositionsWithIcons(t)[0].value,
  linkType: 'No URL',
  imageWidth: '',
  imageHeight: '',
  imageOpacity: '50%',
  fontFamily: 'Verdana',
  fontSize: '14',
  textColor: '#FFFFFF',
  backgroundColor: '#000000',
  borderColor: '#000000',
});

export const annotationSteps = {
  SELECT_TEMPLATE: 'select_template',
  STYLE: 'style',
  SAVE_TEMPLATE: 'save_template',
};
